import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DismissInviteeOrientationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DismissInviteeOrientation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOneTimeMessagesDismissed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"messageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messageId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DismissInviteeOrientation","document":DismissInviteeOrientationDocument}} as const;
export type DismissInviteeOrientationMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
  messageId: Types.Scalars['ID'];
}>;


export type DismissInviteeOrientationMutation = (
  { __typename: 'Mutation' }
  & { addOneTimeMessagesDismissed?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

export type DismissInviteeOrientationMutationFn = Apollo.MutationFunction<
  DismissInviteeOrientationMutation,
  DismissInviteeOrientationMutationVariables
>;

/**
 * __useDismissInviteeOrientationMutation__
 *
 * To run a mutation, you first call `useDismissInviteeOrientationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissInviteeOrientationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissInviteeOrientationMutation, { data, loading, error }] = useDismissInviteeOrientationMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDismissInviteeOrientationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissInviteeOrientationMutation,
    DismissInviteeOrientationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissInviteeOrientationMutation,
    DismissInviteeOrientationMutationVariables
  >(DismissInviteeOrientationDocument, options);
}
export type DismissInviteeOrientationMutationHookResult = ReturnType<
  typeof useDismissInviteeOrientationMutation
>;
export type DismissInviteeOrientationMutationResult = Apollo.MutationResult<DismissInviteeOrientationMutation>;
export type DismissInviteeOrientationMutationOptions = Apollo.BaseMutationOptions<
  DismissInviteeOrientationMutation,
  DismissInviteeOrientationMutationVariables
>;
